import { Authenticate } from "@/domain/authentication";
import { AuthenticatedRepository } from "..";
import { Folder, FolderDispInfo, IFolderRepository } from "../../domain/folder";
import { IAuthenticateBean } from "../authentication/beans";
import { UserTranslator } from "../user/translators";
import { IFolderBean } from "./beans";
import { FolderTranslator } from "./translators";

export class FolderRepository extends AuthenticatedRepository implements IFolderRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getFolderDispInfo(): Promise<FolderDispInfo> {
    const url = "/api/folder/init";
    const result = await this.get(url);
    return FolderTranslator.toFolderDispInfo(result.data);
  }

  async getFolders(): Promise<Folder[]> {
    const url = "/api/folders";
    const result = await this.get(url);
    return this.toFolders(result.data);
  }

  private toFolders(beans: IFolderBean[]): Folder[] {
    if (!beans) { return []; }
    return beans.map(b => FolderTranslator.toFolder(b));
  }

  async getFolder(guid: string): Promise<Folder> {
    const url = "/api/folder/" + guid;
    const result = await this.get(url);
    return FolderTranslator.toFolder(result.data);
  }

  async createFolder(folder: Folder): Promise<void> {
    const url = "/api/folders/create";
    const bean = FolderTranslator.toFolderBean(folder);
    await this.post(url, bean);
  }
  
  async updateFolder(guid: string, folder: Folder): Promise<void> {
    const url = "/api/folder/" + guid + "/update";
    const bean = FolderTranslator.toFolderBean(folder);
    await this.post(url, bean);
  }

  async deleteFolder(guid: string): Promise<void> {
    const url = "/api/folder/" + guid + "/delete";
    await this.post(url);
  }

  async republishFolder(guid: string, password: string): Promise<string> {
    const url = "/api/folder/" + guid + "/republish";
    const result = await this.post(
      url,
      {
        password: password,
      });
    return result.data;
  }

  async getFolderAuthenticationInfo(guid: string): Promise<Authenticate> {
    const url = "/api/folder/" + guid + "/login-info";
    const result = await this.get(url);
    return this.toAuthenticate(result.data);
  }
  
  private toAuthenticate(bean: IAuthenticateBean): Authenticate {
    if (!bean) { throw new Error("bean is empty!!!"); }
    const result = new Authenticate();
    result.token = bean.token;
    result.user = UserTranslator.toUser(bean.user);
    return result;
  }
  
}
